export default __webpack_public_path__ + "static/media/baby-11.ff9e84f1.svg";